import { useState, useEffect, useRef } from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export const PAGE_SIZES = [25, 50, 100]
export const MASKED_VALUE = '***'
export const SEARCH_DEBOUNCE_MS = 300
export const ROW_HEIGHT = 35
export const OVERSCAN = 10

export function TruncatedCell({ value }: { value: string }) {
  const [isTruncated, setIsTruncated] = useState(false)
  const textRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const el = textRef.current
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth)
    }
  }, [value])

  const content = (
    <span ref={textRef} className="truncate block">
      {value}
    </span>
  )

  if (!isTruncated) return content

  return (
    <Tooltip delayDuration={300}>
      <TooltipTrigger asChild>{content}</TooltipTrigger>
      <TooltipContent
        className="w-auto max-w-md break-words whitespace-pre-wrap text-sm"
        side="bottom"
        align="start"
      >
        {value}
      </TooltipContent>
    </Tooltip>
  )
}

export function formatCellValue(value: unknown): string {
  if (value === null || value === undefined) return '-'
  if (value === MASKED_VALUE) return MASKED_VALUE
  if (typeof value === 'boolean') return value ? 'true' : 'false'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}
